import { ZodIssue, z } from 'zod'

export const ErrorResponseSchema = z.object({
  code: z.string(),
  businessMessage: z.string(),
  kind: z.string().optional(),
  subtype: z.string().optional(),
  developerMessage: z.string(),
  validationErrors: z
    .any()
    .transform((x) => x as ZodIssue[])
    .optional(),
  unrecoverable: z.boolean(),
})

export type ErrorResponse = z.infer<typeof ErrorResponseSchema>
